/**
 * Pick the winning ref per (namespace, key) across N providers.
 * Winner = max(updatedAt). A tombstone (deletedAt) wins only if its
 * deletedAt is >= the winning updatedAt.
 */
export function mergeByTimestamp(input) {
    const winners = new Map();
    for (const { providerId, refs } of input) {
        for (const ref of refs) {
            const compoundKey = `${ref.namespace}:${ref.key}`;
            const current = winners.get(compoundKey);
            const candidateTs = effectiveTimestamp(ref);
            if (!current || candidateTs > effectiveTimestamp(current)) {
                winners.set(compoundKey, {
                    namespace: ref.namespace,
                    key: ref.key,
                    updatedAt: ref.updatedAt,
                    deletedAt: ref.deletedAt,
                    providerId,
                });
            }
        }
    }
    return winners;
}
function effectiveTimestamp(ref) {
    if (ref.deletedAt && ref.deletedAt > ref.updatedAt)
        return ref.deletedAt;
    return ref.updatedAt;
}
export function compoundKey(namespace, key) {
    return `${namespace}:${key}`;
}
//# sourceMappingURL=merge-by-timestamp.js.map